import React from 'react'
import ConditionalRender from 'components/ConditionalRender'
import EmptyMonitorResults, { ResultType } from './EmptyMonitorResults'
import { Loader } from '@driftt/tide-core'
import { isEmpty } from 'ramda'
import './style.css'

import infoIconSrc from './info.svg'
import warningIconSrc from './warning.svg'
import errorIconSrc from './error.svg'

const ICON_MAP = {
  info: infoIconSrc,
  warning: warningIconSrc,
  error: errorIconSrc,
}

const TableRow = ({ data }) => (
  <div className="app-monitor-table-row">
    <div className="app-monitor-table-row-icon">
      <img src={ICON_MAP[data.severityLevel]} alt="severity" />
    </div>
    <div className="app-monitor-table-row-timestamp">
      {data.timestamp}
    </div>
    <div className="app-monitor-table-row-description">
      {data.description}
    </div>
  </div>
)

const AppMonitorTable = ({ data, isLoading, isSearching }) => (
  <div className="app-monitor-table">
    <div className="app-monitor-table-header">
      <span className="app-monitor-table-header-time">
        Time
      </span>
      <span className="app-monitor-table-header-description">
        Description
      </span>
    </div>
    <ConditionalRender condition={!isEmpty(data)}>
      {data.map((item, index) => (
        <TableRow key={index} data={item} />
      ))}
    </ConditionalRender>
    <ConditionalRender condition={!isSearching && isEmpty(data)}>
      <EmptyMonitorResults resultType={ResultType.DEFAULT_EMPTY} />
    </ConditionalRender>
    <ConditionalRender condition={isSearching && isEmpty(data)}>
      <EmptyMonitorResults resultType={ResultType.EMPTY} />
    </ConditionalRender>
    <ConditionalRender
      condition={isLoading}
      className="app-monitor-table-loader">
      <Loader />
    </ConditionalRender>
  </div>
)

export default AppMonitorTable
